






























































import Vue from 'vue'
import mixin from '@/mixins/broadcasts-mixin'
import models from '@/mixins/models-mixin'
import { mapGetters } from 'vuex'
import IListTile from '@/types/components/IListTile.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import Broadcast, { BroadcastTemplate } from '@/types/Broadcast.interface'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import IListAction from '@/types/components/IListAction.interface'
import Button from '@/types/components/Button.interface'
import { BroadcastFilterParams } from '@/types/FilterParams.interface'
import { BroadcastParams } from '@/types/PaginationParams.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import IList from '@/types/components/IList.interface'
import FilterButton from '@/components/FilterButton.vue'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    mixins: [mixin, models],
    components: { FilterButton },
    data() {
        return {
            //  Our placeholder for our ilist
            broadcastListPlaceholder: {
                content: 'No Broadcasts Found',
                img: 'noMessages'
            },
            //  Determines if our filter has changed
            filterModified: false,
            //   The groups filter
            filterGroup: {
                selected: {
                    display: 'All Groups',
                    key: 'group_id',
                    value: '*'
                },
                options: [
                    {
                        display: 'All Groups',
                        key: 'group_id',
                        value: '*'
                    }
                ]
            },
            //  The broadcasts status filter
            filterType: {
                selected: {
                    display: 'All',
                    key: 'type',
                    value: 'all'
                },
                options: [
                    {
                        display: 'All',
                        key: 'type',
                        value: 'all'
                    },
                    {
                        display: 'Draft',
                        key: 'type',
                        value: 'draft'
                    },
                    {
                        display: 'Sending',
                        key: 'type',
                        value: 'sending'
                    },
                    {
                        display: 'Completed',
                        key: 'type',
                        value: 'completed'
                    },
                    {
                        display: 'Scheduled',
                        key: 'type',
                        value: 'scheduled'
                    }
                ]
            },
            //  Tells us if we are currently mounted or not
            mounted: false,
            //  The toolbar displayed above the content panel
            toolbar: {
                title: 'Broadcasts',
                help: {
                    title: 'Group text without reply-all made simple',
                    body: `Reach everyone and start individual conversations from one text broadcast, then assign each reply to a teammate.`,
                    embedded: `<div class="mx-4" style="position: relative; padding-bottom: 60.948081264108346%; height: 0;"><iframe src="https://www.loom.com/embed/4bcafc611da54b06879bc281d7aef77f" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>`,
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/4544124-broadcasts-overview`
                    }
                }
            }
        }
    },
    async mounted() {
        //  Set our group filter with our list of groups
        this.setGroupFilter()

        //  Find the type filter that matches the current param
        const typeSelected = this.filterType.options.find(
            (x) => x.value === this.broadcastsParams.type
        )

        //  Set this as the new selected
        this.filterType.selected = typeSelected

        //  If group is NOT set in our params, we are done
        if (!this.broadcastsParams.group_id) return (this.mounted = true)

        //  Else, find the group filter that matches the current param
        const groupSelected = this.filterGroup.options.find(
            (x) => x.value == this.broadcastsParams.group_id
        )

        //  Set this as the new selected
        this.filterGroup.selected = groupSelected

        //  Set mounted to true
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            broadcasts: 'broadcastsViewBroadcasts',
            broadcastsParamsDefault: 'broadcastsViewBroadcastsParamsDefault',
            groups: 'broadcastsViewGroups',
            lastPage: 'broadcastsViewBroadcastsLastPage',
            paginating: 'broadcastsViewPaginating',
            productTier: 'productTier',
            scrollPositionLeft: 'scrollPositionLeft'
        }),
        broadcastsEnabled(): boolean {
            return this.$store.getters.getEnabled('broadcast')
        },
        broadcastsIList(): IList {
            return this.$store.getters.iList('broadcastsViewBroadcastsList')
        },
        broadcastsParams: {
            get(): BroadcastParams {
                return this.$store.getters.broadcastsViewBroadcastsParams
            },
            set(val: BroadcastParams) {
                this.$store.commit('broadcastsViewBroadcastsParamsSet', val)
            }
        },
        imageHeight(): string {
            //  Alias for our breakpoint
            const bp = this.$vuetify.breakpoint

            //  Else if we are on small return 340
            if (bp.smOnly) return ' 340px'

            //  Else return 610
            return '610px'
        },
        tools(): Button[] {
            return [
                {
                    text: 'New Broadcast',
                    icon: 'bi-megaphone-fill',
                    color: 'primary',
                    small: true,
                    callback: () => this.toolbarNewBroadcast()
                }
            ] as Button[]
        }
    },
    methods: {
        broadcastColumns(broadcast: Broadcast): IListTileColumn[] {
            //  Our group this broadcast is assigned to
            const group = broadcast.group
                ? `Assigned Group: ${broadcast.group.name}`
                : null

            //  Create our first column
            const one: IListTileColumn = {
                line1: this.$options.filters.broadcastName(broadcast),
                line2: this.broadcastSentAt(broadcast),
                line3: group
            }

            //  Create our second column
            const two: IListTileColumn = {
                centered: true,
                line1: this.broadcastStatus(broadcast)
            }

            //  If broadcast status is sedning, add tool tip to status indicator
            if (broadcast.status == 'sending') {
                two.hoverText =
                    "This Broadcast is currently sending. You'll be notified once the Broadcast has completed"
            }

            //  Create our columns container
            const columns: IListTileColumn[] = [one, two]

            //  Return our columns
            return columns
        },
        broadcastIcon(): IListIcon {
            //  We use the same icon for every broadcast
            const icon = 'bi-megaphone-fill'

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our IListIcon object
            return listIcon
        },
        broadcastTile(): IListTile {
            return {
                actionContent: (b: Broadcast): IListAction => this.broadcastActions(b),
                leftIcon: (): IListIcon => this.broadcastIcon(),
                columns: (b: Broadcast): IListTileColumn[] => this.broadcastColumns(b),
                callback: (b: Broadcast): void => this.showBroadcast(b)
            }
        },
        //  Tells us if we have modified the filter in any sort of way
        checkForFilter(): void {
            //  Get the default pagination params
            const defaults = this.broadcastsParamsDefault

            //  Get the current params
            const params = this.broadcastsParams

            //  Determine if we have modified it at all
            const isModified = !window._.isEqual(defaults, params)

            //  Return our result
            this.filterModified = isModified
        },
        emptyNewBroadcast(): void {
            //  Report to segment
            Analytics.track('EmptyStateBroadcastStarted', {
                path: 'Start from Scratch',
                tier: this.productTier
            })

            //  Navigate to Broadcasts
            this.$router.push('broadcasts/create')
        },
        onFilterChanged(filter: BroadcastFilterParams): void {
            //  Grab the key and value from our filter
            const key = filter.key
            const value = filter.value

            //  Get our current params
            const params = this.broadcastsParams

            //  Check if we currently have this filter applied
            const isSame = params[key] === value

            //  If it is the same, don't do anything
            if (isSame) return

            //  Else, apply this to our params
            params[key] = value

            //  Also set page to 1 since we changed filter
            params.page = 1

            //  (our computed setter will apply this in the store)
            this.broadcastsParams = params

            //  Deselect multiselected items
            this.$refs.broadcastsList.multiSelectReset()

            //  The filter was changed so we should paginate the new filter
            this.$store.dispatch('broadcastsViewBroadcastsPaginate')

            //  Check if our filter changed
            this.checkForFilter()
        },
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.broadcastsParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  (our computed setter will apply this in the store)
            this.broadcastsParams = params

            //  Deselect multiselected items
            this.$refs.broadcastsList.multiSelectReset()

            //  Paginate the next page
            this.$store.dispatch('broadcastsViewBroadcastsPaginate')
        },
        popTemplateCenter(): void {
            //  Our width depends on screen size
            const width = this.$vuetify.breakpoint.xsOnly ? '500px' : '850px'

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'template-center',
                width: width,
                closeable: true,
                closeOnSubmit: true,
                callback: (template: BroadcastTemplate) => {
                    //  Set our current template in the store
                    this.$store.commit('broadcastsViewSelectedTemplateSet', template)

                    //  Report to segment
                    Analytics.track('EmptyStateBroadcastStarted', {
                        path: 'Template',
                        tier: this.productTier
                    })

                    //  Navigate to our broadcast form
                    this.$router.push('/broadcasts/create')
                }
            })
        },
        setGroupFilter(): void {
            //  Iterate groups, adding each to the groups filter
            for (const g of this.groups) {
                this.filterGroup.options.push({
                    display: `${g.name} (${g.persons_count})`,
                    key: 'group_id',
                    value: g.id
                })
            }

            //  If group filter is set in the url, set it as selected
            if (this.$route.query.group) {
                //  Get the group id from the query param
                const group_id = this.$route.query.group

                //  Find the group in the filter options
                const selected = this.filterGroup.options.find((x) => x.value == group_id)

                //  Set the selected group filter
                this.filterGroup.selected = selected

                //  Grab our params
                const params = this.broadcastsParams

                //  Apply our filter to our params
                params[selected.key] = selected.value

                //  Also set page to 1 since we changed filter
                params.page = 1

                //  Apply this in our store
                this.broadcastsParams = params
            }
        },
        //  Set the selected broadcast and nav to broadcast profile
        showBroadcast(broadcast: Broadcast): void {
            //  Report to analytics
            Analytics.track('BroadcastSelected', { type: broadcast.status })

            //  If broadcast status is 'draft' navigate to BroadcastEdit with id
            if (broadcast.status == 'draft') {
                this.$router.push(`broadcasts/${broadcast.id}/edit`)
                return
            }

            //  Else, navigate to the currently selected broadcast
            this.$router.push(`/broadcasts/${broadcast.id}`)
        },
        toolbarNewBroadcast(): void {
            //  Report to Analytics
            Analytics.track('BroadcastListNewBroadcast')

            //  Go to broadcasts create
            this.$router.push('/broadcasts/create')
        }
    },
    watch: {
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        },
        groups(): void {
            this.setGroupFilter()
        }
    }
})
